module.exports = __webpack_public_path__ + "assets/media/day14.3e49fdc9.mp3";